// © Microsoft Corporation. All rights reserved.
export function getRootConfigRef() {
    return { experienceType: "AppConfig", instanceSrc: "default" };
}
//# sourceMappingURL=getRootConfigRef.js.map